import { ListItem, ThematicsIconProvider } from '@components';
import { Container, Icon, Typography } from '@design-system';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormationListPageSkeleton } from './FormationListPageSkeleton';
import { useFormationListPageVM } from './useFormationListPageVM';

export const FormationListPage: React.FC = () => {
    const { isLoading, categories } = useFormationListPageVM();
    const navigate = useNavigate();

    return (
        <Container className="formation-list-page" height="fill">
            <Typography intrinsic="h2" defaultSpacing>
                Les catégories de formation
            </Typography>

            {isLoading ? (
                <FormationListPageSkeleton />
            ) : (
                <>
                    {categories.length > 0 ? (
                        categories.map((category) => (
                            <ListItem
                                key={category.id}
                                title={category.title}
                                type="default"
                                icon={<Icon icon={<ThematicsIconProvider icon={category.icon} />} size={24} color="green" />}
                                onClick={() => navigate(`/sante-securite/formations/list/${category.id}`)}
                            />
                        ))
                    ) : (
                        <Typography intrinsic="h3" defaultSpacing>
                            Vous n'avez aucune formation en cours
                        </Typography>
                    )}
                </>
            )}
        </Container>
    );
};
